<template>
  <div class="app-textarea-root">
    <label v-if="label" class="app-textarea-label" :for="inputId">{{ label }}</label>
    <textarea
      :id="inputId"
      class="app-textarea"
      :class="textareaClasses"
      :value="currentValue"
      :placeholder="placeholder"
      :rows="rows"
      :disabled="disabled"
      :readonly="readonly"
      v-bind="$attrs"
      @input="onInput"
      @blur="onBlur"
      @focus="onFocus"
    />
    <small v-if="errorMessage" class="app-textarea-error app-textarea-error--visible">{{ errorMessage }}</small>
  </div>
</template>

<script>
export default {
  name: 'AppTextarea',
  inheritAttrs: false,
  props: {
    modelValue: { type: String, default: undefined },
    value: { type: String, default: undefined },
    label: { type: String, default: '' },
    inputId: { type: String, default: () => 'app-textarea-' + Math.random().toString(36).substr(2, 9) },
    placeholder: { type: String, default: '' },
    rows: { type: Number, default: 3 },
    maxRows: { type: Number, default: null },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    size: { type: String, default: null },
    state: { type: Boolean, default: null },
    errorMessage: { type: String, default: '' }
  },
  emits: ['update:modelValue', 'input', 'blur', 'focus'],
  computed: {
    currentValue() {
      return this.modelValue !== undefined ? this.modelValue : this.value
    },
    textareaClasses() {
      return {
        'app-textarea--sm': this.size === 'sm',
        'app-textarea--lg': this.size === 'lg',
        'app-textarea--valid': this.state === true,
        'app-textarea--invalid': this.state === false || !!this.errorMessage
      }
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value)
      this.$emit('update:modelValue', event.target.value)
    },
    onBlur(event) { this.$emit('blur', event) },
    onFocus(event) { this.$emit('focus', event) }
  }
}
</script>

<style scoped>
.app-textarea-root { width: 100%; }
.app-textarea-label {
  display: block;
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #939393;
}
.app-textarea {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  resize: vertical;
}
.app-textarea:focus { border-color: #80bdff; outline: 0; box-shadow: 0 0 0 0.2rem rgba(0,123,255,0.15); }
.app-textarea:disabled { background: #e9ecef; opacity: 1; }
.app-textarea--sm  { padding: 0.25rem 0.5rem; font-size: 0.875rem; }
.app-textarea--lg  { padding: 0.5rem 1rem; font-size: 1.25rem; }
.app-textarea--valid  { border-color: #34C38F; }
.app-textarea--invalid { border-color: #F46A6A; }
.app-textarea--invalid:focus { box-shadow: 0 0 0 0.2rem rgba(244,106,106,0.2); }

.app-textarea-error { display: none; margin-top: 4px; font-size: 80%; color: #F46A6A; }
.app-textarea-error--visible { display: block; }
</style>
